import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListBuilders from "../Components/Builder Approval/listBuilders";
import AddBuilder from "../Components/Builder Approval/addBuilder";
import ViewBuilder from "../Components/Builder Approval/viewBuilder";
import ReviewBuilder from "../Components/Builder Approval/reviewBuilder";

const BuilderRoutes = () => {

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route
        path="/builders"
        element={<ListBuilders></ListBuilders>}
      ></Route>
      <Route path="/builders/add" element={canAdd ? <AddBuilder /> : <Navigate to="/builders" replace />}></Route>
      <Route path="/builders/view/:id" element={<ViewBuilder> </ViewBuilder>}></Route>
      <Route path="/builders/:id/review" element={<ReviewBuilder></ReviewBuilder>}></Route>
    </Routes>
  );
};

export default BuilderRoutes;
